import React from 'react'
import styled from 'styled-components'
import { color } from '@primer-io/goat'

import Flex from 'ds/Flex'
import addPx from 'utils/addPx'

const defaultSize = { sm: 28, md: 40 }

const Icon = styled.img`
	background: ${color('gray-100')};
	border-radius: 25%;
	object-fit: contain;
`

const Wrapper = styled(Flex).attrs(() => ({
	flow: 'row nowrap',
	align: 'center',
	justify: 'flex-start',
}))`
	margin-right: 0.4em;
	position: relative;
	top: 0.06em;

	> * {
		margin-right: 0;
	}
	> *:not(:first-of-type) {
		margin-left: -${p => (p.size?.sm ?? defaultSize.sm) / 3.2}px;

		${p => p.theme.above('medium')`
      margin-left: -${(p.size?.md ?? defaultSize.md) / 3.2}px;
    `}
	}

	${Icon} {
		width: ${p => addPx(p.size?.sm ?? defaultSize.sm)};
		height: ${p => addPx(p.size?.sm ?? defaultSize.sm)};

		${p => p.theme.above('medium')`
      width: ${p => addPx(p.size?.md ?? defaultSize.md)};
      height: ${p => addPx(p.size?.md ?? defaultSize.md)};
    `}
	}
`
const TitleIcons = ({ icons, size }) => (
	<>
		<Wrapper size={size}>
			{icons.map(({ src, name }, index) => (
				<Icon key={src} src={src} name={name} variant={index === 0 && 'grey'} />
			))}
		</Wrapper>
	</>
)

export default TitleIcons
